import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import Form from '../../components/GdprProfile/Form';
import useAnalytics from '../../hooks/useAnalytics';
import { URL_GDPR_PROFILE } from '../../router/constants';
import { PERMISSION_GDPR_PROFILE_LIST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/gdpr-profile/edit/$customerId/$id')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_GDPR_PROFILE_LIST, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.gdprProfile',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditGdprProfileRoute,
});

function EditGdprProfileRoute() {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  const { customerId, id } = Route.useParams();

  const handleClose = useCallback(() => {
    navigate({ to: URL_GDPR_PROFILE });
    trackEvent(['gdprProfiles', 'click', 'GDPR profile close']);
  }, [navigate, trackEvent]);

  return (
    <Form
      closeCallback={handleClose}
      editingItemId={Number(id)}
      customerId={Number(customerId)}
      isEdited
    />
  );
}
